import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} className={className} data-id="element-342">
    {children}
  </motion.div>;
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export const CTAButton = ({
  href,
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) => {
  return <a href={href} className={`
        inline-flex items-center justify-center gap-2 font-bold rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg
        ${fullWidth ? 'w-full' : 'px-8'} py-4 text-lg md:text-xl
        ${variant === 'primary' ? 'bg-brandOrange hover:bg-brandOrange-hover text-white' : 'bg-white text-navy hover:bg-gray-50 border-2 border-navy'}
        ${className}
      `} data-id="element-343">
      {children}
    </a>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-16 md:py-24 px-4 md:px-8 overflow-hidden ${className}`} data-id="element-344">
    <div className="max-w-6xl mx-auto" data-id="element-345">{children}</div>
  </section>;